import React from 'react';
import { useCoupon } from '../../../commons/customHooks/GiftBox';
import VideoCouponBoxComponent from '../components/couponBox';
import * as stepAction from '../redux/actions';

const VideoCouponBoxContainer = () => {

  const [ coupon, isProcessing ] = useCoupon();
  return <VideoCouponBoxComponent 
    pushDataVideoCoupon={stepAction.pushDataVideoStepFour}
    coupon={coupon}
    isProcessing={isProcessing}
  />;
};

export default VideoCouponBoxContainer;
